<template>
    <BModal :model-value="modal" centered @update:modelValue="updateModal" no-close-on-backdrop scrollable>
        <template #header>
            <div
                class="d-flex align-items-center justify-content-between modal-title w-100"
            >
                <h5 class="">Route</h5>
                <BButton
                    variant="link"
                    class="close"
                    @click="updateModal(false)"
                >
                    <i class="ion ion-android-close"></i>
                </BButton>
            </div>
        </template>

        <BForm @submit.stop.prevent>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="From *"
                        label-for="from_destination_uuid"
                        class="text-start mb-3"
                    >
                        <v-select
                            v-model="form.from_destination_uuid"
                            label="name"
                            :options="destinationList"
                            :reduce="(item) => item.uuid"
                            :searchable="true"
                            :clearable="true"
                            placeholder="Select Start Destination"
                            :class="{
                                'is-invalid':
                                    v$.form.from_destination_uuid.$dirty &&
                                    v$.form.from_destination_uuid.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.from_destination_uuid.$dirty &&
                                v$.form.from_destination_uuid.$invalid
                            "
                        >
                            {{
                                v$.form.from_destination_uuid.$errors[0]
                                    ?.$message
                            }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="To *"
                        label-for="to_destination_uuid"
                        class="text-start mb-3"
                    >
                        <v-select
                            v-model="form.to_destination_uuid"
                            label="name"
                            :options="destinationList"
                            :reduce="(item) => item.uuid"
                            :searchable="true"
                            :clearable="true"
                            placeholder="Select End Destination"
                            :class="{
                                'is-invalid':
                                    v$.form.to_destination_uuid.$dirty &&
                                    v$.form.to_destination_uuid.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.to_destination_uuid.$dirty &&
                                v$.form.to_destination_uuid.$invalid
                            "
                        >
                            {{
                                v$.form.to_destination_uuid.$errors[0]?.$message
                            }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Distance (Km)"
                        label-for="code"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.distance"
                            type="number"
                            id="distance"
                            placeholder="Enter Distance"
                            :class="{
                                'is-invalid':
                                    v$.form.distance.$dirty &&
                                    v$.form.distance.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.distance.$dirty &&
                                v$.form.distance.$invalid
                            "
                        >
                            {{ v$.form.distance.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Duration"
                        label-for="duration"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.duration"
                            type="number"
                            id="duration"
                            placeholder="Enter Duration"
                            :class="{
                                'is-invalid':
                                    v$.form.duration.$dirty &&
                                    v$.form.duration.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.duration.$dirty &&
                                v$.form.duration.$invalid
                            "
                        >
                            {{ v$.form.duration.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="Duration Unit"
                        label-for="duration_unit"
                        class="text-start mb-3"
                    >
                        <BFormSelect
                            id="duration_unit"
                            v-model="form.duration_unit"
                            :options="durationUnitOptions"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    v$.form.duration_unit.$dirty &&
                                    v$.form.duration_unit.$invalid,
                            }"
                        >
                            <template #first>
                                <option disabled selected value="">
                                    Select Duration Unit
                                </option>
                            </template>
                        </BFormSelect>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.duration_unit.$dirty &&
                                v$.form.duration_unit.$invalid
                            "
                        >
                            {{ v$.form.duration_unit.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>

            <BRow>
                <BCol>
                    <BFormGroup
                        label="Description"
                        label-for="description"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.description"
                            id="description"
                            placeholder="Enter Description"
                            :rows="5"
                            :class="{
                                'is-invalid':
                                    v$.form.description.$dirty &&
                                    v$.form.description.$invalid,
                            }"
                        >
                        </BFormTextarea>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.description.$dirty &&
                                v$.form.description.$invalid
                            "
                        >
                            {{ v$.form.description.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
        </BForm>

        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" class="me-2" @click="handleAction"
                    >Save</BButton
                >
                <BButton variant="danger" @click="updateModal(false)"
                    >Cancel</BButton
                >
            </div>
        </template>
    </BModal>
</template>

<script setup>
import axios from "axios";
import { defineProps, defineEmits, reactive, watch, ref, onMounted } from "vue";
import {
    BModal,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BFormSelect,
    BFormTextarea,
} from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required} from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

const auth = useAuthStore();
const $loading = useLoading();
const toast = useToast();

//Duration Unit Options
const durationUnitOptions = [
    {
        value: "Minutes",
        text: "Minutes",
    },
    {
        value: "Hours",
        text: "Hours",
    },
];

// Props
const props = defineProps({
    action: String,
    modal: Boolean,
    selectedData: Object,
});

// Emit
const emit = defineEmits(["update:modal", "addOrUpdate"]);

// Function to update modal visibility
const updateModal = (value) => {
    emit("update:modal", value); // Sync modal state with parent
};

const resetForm = () => {
    Object.assign(form, { ...formData });
    v$.value.$reset();
};

const formData = {
    from_destination_uuid: "",
    to_destination_uuid: "",
    distance: "",
    duration: "",
    duration_unit: "",
    description: "",
};

const form = reactive({ ...formData });

// Init data jika update
watch(
    () => props.selectedData,
    (newData) => {
        // jika props.selectedData != null (action edit)
        if (newData && Object.keys(newData).length > 0) {
            const routeData = {
                ...newData,
                from_destination_uuid: newData.from?.uuid || null,
                to_destination_uuid: newData.to?.uuid || null,
                duration_unit: newData.duration_unit ?? "",
            };
            Object.assign(form, { ...routeData });
        } else {
            Object.assign(form, { ...formData });
        }
    },
    { immediate: true }
);

const rules = {
    form: {
        from_destination_uuid: {
            required: helpers.withMessage(
                "Start destination is required",
                required
            ),
        },
        to_destination_uuid: {
            required: helpers.withMessage(
                "End destination is required",
                required
            ),
        },
        distance: {},
        duration: {},
        duration_unit: {},
        description: {},
    },
};

const v$ = useVuelidate(rules, { form });

const handleAction = () => {
    props.selectedData.uuid ? update() : create();
};

const create = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/route/add`,
                {
                    from_destination_uuid: form.from_destination_uuid,
                    to_destination_uuid: form.to_destination_uuid,
                    distance: form.distance,
                    duration: form.duration,
                    duration_unit: form.duration_unit,
                    description: form.description,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};

const update = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            const response = await axios.put(
                `${process.env.VUE_APP_API_URL}/route/edit/${props.selectedData.uuid}`,
                {
                    from_destination_uuid: form.from_destination_uuid,
                    to_destination_uuid: form.to_destination_uuid,
                    distance: form.distance,
                    duration: form.duration,
                    duration_unit: form.duration_unit,
                    description: form.description,
                },
                {
                    headers: {
                        "Content-type": "application/json",
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};

let destinationList = ref([]);

const getAllDestination = async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/destination`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status) {
            destinationList.value = res.data;
        }
    } finally {
        loader.hide();
    }
};

onMounted(() => {
    getAllDestination();
});
</script>
